// import { useState, useEffect } from "react";
// import Footer from "../../../components/Footer/Footer";
// import InnerNav from "../../../components/InnerNav/InnerNav";
// import Zodiac from "../../../components/ZodiacSign/Zodiac";
// import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";

// import "./Vivah.scss";
// import axios from "axios";

// const Vivah = () => {
//   const [expandedMonths, setExpandedMonths] = useState({});
//   const [vivahData, setVivahData] = useState({});
//   const [loading, setLoading] = useState(true);
//   const currentYear = new Date().getFullYear();
//   const [year, setYear] = useState(currentYear);
//   const [location, setLocation] = useState("Kolkata");

//         // temporary values (for input fields)
// const [tempYear, setTempYear] = useState(currentYear);
// const [tempLocation, setTempLocation] = useState("Kolkata");


//   const handleToggle = (index) => {
//     setExpandedMonths((prev) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));
//   };

//   useEffect(() => {
//     const fetchVivahData = async () => {
//       try {
//         const response = await axios.get(
//           `https://core-c343.onrender.com/api/vivah-muhurat?year=${year}&location=${encodeURIComponent(location)}`
//         );
//         const data = response.data;
//         setVivahData(data.vivahMuhurat || {});
         
//       } catch (error) {
//         console.error("Error fetching vivah muhurat:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchVivahData();
//   }, [year, location]);

//   const formatDate = (dateStr) => {
//     const [year, month, day] = dateStr.split("-");
//     return `${month}/${day}/${year}`;
//   };


//     const handleSubmit = () => {
//   setYear(tempYear);
//   setLocation(tempLocation);
// };

//   return (
//     <div className="Vivah-container">
//       <InnerNav />
//       <div className="Vivah-content">
//         <Zodiac />
//         <div className="location-date">
//         <div className="year-selector">
//         <label htmlFor="year">Select Year: </label>
//         <input
//           id="year"
//           type="number"
//           min="1900"
//           max="2100"
//           value={tempYear}
//           onChange={(e) => setTempYear(Number(e.target.value))}
//         />
//         <button className="submit" onClick={handleSubmit}>Submit</button>
//       </div>


//       <div className="input-with-icon">
//         <span className="icon">📍</span>
//         <input
//           type="text"
//           value={tempLocation}
//           onChange={(e) => setTempLocation(e.target.value)}
//           placeholder="📍Enter location"
//         />
//       </div>
//           </div>
//         <div className="meaning">
//           <p className="meaning1">⚠️: Not Recommended / Ashubh Muhurat</p>
//         <p className="meaning1">✅: Shubh Muhurat</p>
//       </div>
//         <h1 className="vivah-title">Vivah Muhurat</h1>

//         {loading ? (
//           <p>Loading Vivah Muhurat...</p>
//         ) : Object.keys(vivahData).length > 0 ? (
//           Object.entries(vivahData).map(([monthName, entries], index) => {
//             const isExpanded = expandedMonths[index];
//             const visibleEntries = isExpanded ? entries : entries.slice(0, 6);

//             return (
//               <div className="monthVivah" key={monthName}>
//                 <h2 className="month-heading">{monthName}, {year}</h2>
//                 <div className="list-of-vivah">
//                   {visibleEntries.map((item, i) => (
//                     <div className="vivah-card" key={i}>
//                       <div className="vivah-info">
//                         <p className="tag">{item.tag ? item.tag.slice(0, 2) : ""}</p>
//                         <p><strong>Date:</strong> {formatDate(item.date)}</p>
//                         {item.tithi && <p><strong>Tithi:</strong> {item.tithi}</p>}
//                         {item.nakshatra && <p><strong>Nakshatra:</strong> {item.nakshatra}</p>}
//                         {item.weekday && <p><strong>Weekday:</strong> {item.weekday}</p>}
//                         {item.rating && <p><strong>Rating:</strong> {item.rating}</p>}
//                         {item.verdict && <p><strong>Verdict:</strong> {item.verdict}</p>}
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 {entries.length > 6 && (
//                   <button className="toggle-btn" onClick={() => handleToggle(index)}>
//                     {isExpanded ? "Show less" : "Show more"}
//                   </button>
//                 )}
//               </div>
//             );
//           })
//         ) : (
//           <p>No Vivah data available for the current year.</p>
//         )}

        
//         <section className="vivah-wrapper">
//           <h1 className="vivah-title">Hindu Marriage Dates</h1>
//           <div className="vivah-texts">
//             <p>There is no fixed formula to calculate an auspicious Muhurat for marriage rituals. Even Hindu sages had different viewpoints on some of the elements considered while selecting auspicious marriage dates. Hence one has to be careful and should analyze different opinions while calculating auspicious dates for marriage.

// Further one needs to be practical while finding auspicious dates and should consider most significant elements and
//  ignore less significant elements. If you want to understand how auspicious marriage dates are calculated on this page please read Vivah Dates Calculations</p>

//           <p>According to Muhurta Chintamani and other religious texts like Dharmasindhu, marriage rituals should not be performed while Shukra Tara and Guru Tara are Asta / set. Visit Shukra Asta and Guru Asta to know the exacting timings of Asta and Uday. Hence Panchang Shuddhi for auspicious marriage dates is done after removing days when Shukra and Guru Tara are set or combusted.
//              All days during Leaped Lunar month are also removed during Panchangam Shuddhi.</p>

//           </div>
//         </section>
//         <MuhuratLink />
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Vivah;


import { useState, useEffect } from "react";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import city from '../../../city.json'

import "./Vivah.scss";
import axios from "axios";

const Vivah = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [vivahData, setVivahData] = useState({});
  const [loading, setLoading] = useState(true);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [location, setLocation] = useState("Kolkata");

  const [tempYear, setTempYear] = useState(currentYear);
  const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);

  const [showPopup, setShowPopup] = useState(false);

  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const fetchVivahData = async () => {
      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/vivah-muhurat?year=${year}&location=${encodeURIComponent(location)}`
        );
        const data = response.data;
        setVivahData(data.vivahMuhurat || {});
      } catch (error) {
        console.error("Error fetching vivah muhurat:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVivahData();
  }, [year, location]);

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
  };

  const handleSubmit = () => {
    setYear(tempYear);
    setLocation(tempLocation);
  };

    const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  return (
    <div className="Vivah-container">
      <InnerNav />
      <div className="Vivah-content">
        <Zodiac />
        <div className="location-date">
          <div className="year-selector">
            <label htmlFor="year">Select Year: </label>
            <input
              id="year"
              type="number"
              min="1900"
              max="2100"
              value={tempYear}
              onChange={(e) => setTempYear(Number(e.target.value))}
            />
            <button className="submit" onClick={handleSubmit}>Submit</button>
          </div>

           <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
        </div>

        <div className="meaning">
          <p className="meaning1">⚠️: Not Recommended / Ashubh Muhurat</p>
          <p className="meaning1">✅: Shubh Muhurat</p>
        </div>

        <h1 className="vivah-title">Vivah Muhurat</h1>

        {loading ? (
          <p>Loading Vivah Muhurat...</p>
        ) : Object.keys(vivahData).length > 0 ? (
          Object.entries(vivahData).map(([monthName, entries], index) => {
            const isExpanded = expandedMonths[index];
            const visibleEntries = isExpanded ? entries : entries.slice(0, 6);

            return (
              <div className="monthVivah" key={monthName}>
                <h2 className="month-heading">{monthName}, {year}</h2>
                <div className="list-of-vivah">
                  {visibleEntries.map((item, i) => (
                    <div className="vivah-card" key={i}>
                      <div className="vivah-info">
                        <p className="tag">{item.tag ? item.tag.slice(0, 2) : ""}</p>
                        <p><strong>Date:</strong> {formatDate(item.date)}</p>
                        {item.tithi && <p><strong>Tithi:</strong> {item.tithi}</p>}
                        {item.nakshatra && <p><strong>Nakshatra:</strong> {item.nakshatra}</p>}
                        {item.weekday && <p><strong>Weekday:</strong> {item.weekday}</p>}
                        {item.rating && <p><strong>Rating:</strong> {item.rating}</p>}
                        {item.verdict && <p><strong>Verdict:</strong> {item.verdict}</p>}
                      </div>
                    </div>
                  ))}
                </div>

                {entries.length > 6 && (
                  <button className="toggle-btn" onClick={() => handleToggle(index)}>
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p>No Vivah data available for the current year.</p>
        )}

        <section className="vivah-wrapper">
          <h1 className="vivah-title">Hindu Marriage Dates</h1>
          <div className="vivah-texts">
            <p>
              There is no fixed formula to calculate an auspicious Muhurat for marriage rituals. Even Hindu sages had different viewpoints on some elements considered while selecting auspicious marriage dates. Hence one has to be careful and analyze different opinions while calculating auspicious dates for marriage.
            </p>

            <p>
              Further, one needs to be practical while finding auspicious dates and should consider the most significant elements while ignoring less significant elements. Click
               <span 
              className="link-text" 
              onClick={() => setShowPopup(true)}>Vivah Dates Calculations</span> to see key factors considered for Solar Months and Rashi guidelines.
            </p>

            <p>
              According to Muhurta Chintamani and Dharmasindhu, marriage rituals should not be performed while Shukra Tara and Guru Tara are Asta/set. Panchang Shuddhi removes such days, as well as days during a Leaped Lunar month.
            </p>
          </div>
        </section>

        <MuhuratLink />
      </div>
      <Footer />

      {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Vivah Dates Guidelines</h2>
            <p><strong>Solar Months:</strong> Only solar months are considered (except Chaturmas).</p>
            <p><strong>Shubha Vivah (Sun in these Rashis):</strong> Mesha / Aries, Vrishabha / Taurus, Mithuna / Gemini, Vrischika / Scorpio, Makara / Capricorn, Kumbha / Aquarius</p>
            <p><strong>Not Recommended (Sun in these Rashis):</strong> Karka / Cancer, Simha / Leo, Kanya / Virgo, Tula / Libra, Dhanu / Sagittarius, Meena / Pisces</p>
            <button className="popup-close" onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Vivah;
